<template>
    <div class="migrol-form__address-readonly" :class="ComputedClass">
        <div class="migrol-form__address-readonly-group">
            <div class="migrol-form__address-readonly-block">
                <label class="migrol-form__address-readonly-label" v-if="label !== ''">{{label}}</label>
                <div v-if="address.salutation === salutations.Mr">{{Strings['Enums.Salutation.Mr']}} {{address.firstName}} {{address.lastName}}</div>
                <div v-if="address.salutation === salutations.Mrs">{{Strings['Enums.Salutation.Mrs']}} {{address.firstName}} {{address.lastName}}</div>
                <div v-if="address.salutation === salutations.Company">{{address.companyName}}</div>
                <div v-if="address.street">{{address.street}} {{address.streetNumber}}</div>
                <div v-if="address.addressLine2">{{address.addressLine2}}</div>
                <div>{{address.zipcode}} {{address.city}}</div>
            </div>
        </div>
        <div class="migrol-form__address-readonly-group">
            <div class="migrol-form__address-readonly-block" v-if="address.phone && showPhone">
                <label class="migrol-form__address-readonly-label">{{Strings['Global.Address.Phone']}}</label>
                {{address.phone}}
            </div>

            <div class="migrol-form__address-readonly-block" v-if="address.emailAddress && showEmail">
                <label class="migrol-form__address-readonly-label">{{Strings['Global.Address.Email']}}</label>
                {{address.emailAddress}}
            </div>

            <div class="migrol-form__address-readonly-block" v-if="address.cumulusNumber && showCumulus">
                <label class="migrol-form__address-readonly-label">{{Strings['Global.Address.CumulusNumber']}}</label>
                {{address.cumulusNumber}}
            </div>
        </div>
    </div>
</template>

<script>
    import { Salutations } from '@/utils/constants';

    export default {
        props: {
            address: {
                type: Object,
                required: true
            },
            showPhone: {
                type: Boolean,
                default: true
            },
            showEmail: {
                type: Boolean,
                default: true
            },
            showCumulus: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                required: false,
                default: ''
            },
            layout: {
                type: String,
                required: false,
                default: ''
            }
        },
        computed: {
            ComputedClass() {
                return this.layout === '' ? '' : 'migrol-form__address-readonly--' + this.layout;
            },
            Strings() {
                return this.$migrolVueLibraryData.Strings;
            }
        },
        data() {
            return {
                salutations: Salutations,
                editingPhone: false,
                editingEmail: false,
                editingCumulus: false
            }
        }
    };
</script>